import { render, staticRenderFns } from "./ReportsRedistributionDynamic.vue?vue&type=template&id=6adfc9ff&"
import script from "./ReportsRedistributionDynamic.vue?vue&type=script&lang=js&"
export * from "./ReportsRedistributionDynamic.vue?vue&type=script&lang=js&"
import style0 from "./ReportsRedistributionDynamic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports